export default __webpack_public_path__ + "static/email-c9a3694e01a03e33db2d527e00bdc87d.jpg";